import $foreign from "./foreign.cjs";
var _unsafePartial = $foreign._unsafePartial;
export { _unsafePartial };
